import * as React from 'react';
import * as cx    from 'classnames';

const LoadingAnimation = (props) => (
    <div className={cx('loader', props.className)}>
        <svg className="loader__circle" viewBox="25 25 50 50">
            <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#6ad7eb" />
                    <stop offset="25%" stopColor="#6ad7eb" />
                    <stop offset="50%" stopColor="#33BCD4" />
                    <stop offset="100%" stopColor="#08788C" />
                </linearGradient>
            </defs>
            <circle className="loader__path" stroke="url(#gradient)" cx="50" cy="50" r="20" fill="none" strokeWidth="0.25" strokeMiterlimit="10"/>
        </svg>
    </div>
);

export default LoadingAnimation;



// WEBPACK FOOTER //
// ./src/components/LoadingAnimation.tsx